import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectAppraisalProductSchema = createSelector(
  getSystem,
  ({ appraisalProductSchema }) => appraisalProductSchema,
);

export const selectAppraisalSurchargeSchema = createSelector(
  getSystem,
  ({ appraisalSurchargeSchema }) => appraisalSurchargeSchema,
);
